<template>
  <iColumn gap="large">
    <iColumn gap="none">
      <iTextInput
        :model-value="form.name"
        label="Name"
        required
        width="fill"
        @update:model-value="updateField('name', $event)"
      />
      <iText v-if="errors.name" variant="error">
        {{ errors.name }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iTextInput
        :model-value="form.title"
        label="Title"
        required
        width="fill"
        @update:model-value="updateField('title', $event)"
      />
      <iText v-if="errors.title" variant="error">
        {{ errors.title }}
      </iText>
    </iColumn>

    <iColumn gap="none">
      <iTextArea
        :model-value="form.description"
        label="Description"
        :rows="3"
        width="fill"
        @update:model-value="updateField('description', $event)"
      />
      <iText v-if="errors.description" variant="error">
        {{ errors.description }}
      </iText>
    </iColumn>

    <iTextInput
      :model-value="form.sponsoredByPrefix"
      label="Sponsored By Prefix"
      width="fill"
      @update:model-value="updateField('sponsoredByPrefix', $event)"
    />
    <iTextInput
      :model-value="form.destinationUrl"
      label="Destination URL"
      width="fill"
      @update:model-value="updateField('destinationUrl', $event)"
    />

    <iColumn gap="extraSmall">
      <iLabel>Image</iLabel>
      <iRow gap="small" vertical-align="middle">
        <iImageContainer
          v-if="form.imageUrl"
          :src="form.imageUrl"
          :height="100"
          :width="100"
        />
        <iUploader @upload-file="handleImageSelected">
          <iButton
            variant="secondary"
            size="small"
            :is-loading="isLoading"
            loading-text="Uploading"
            loading-spinner-position="inside"
          >
            {{ form.imageUrl ? 'Change' : 'Upload' }} Image
          </iButton>
        </iUploader>
      </iRow>
      <iText v-if="errors.image" variant="error">
        {{ errors.image }}
      </iText>
    </iColumn>
  </iColumn>
</template>

<script>
export default {
  name: "NativeAdForm",
  props: {
    modelValue: { type: Object, required: true },
    errors: { type: Object, required: true },
    isLoading: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "upload-image", "clear-error"],
  computed: {
    form() {
      return this.modelValue;
    },
  },
  methods: {
    updateField(field, value) {
      this.$emit("update:modelValue", { ...this.form, [field]: value });
      this.$emit("clear-error", field);
    },
    handleImageSelected(file) {
      this.$emit("upload-image", file);
    },
  },
};
</script>

<style scoped>
</style>
